import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/**
 * Every time in Tracer is shown in UTC, with the zone written out. The same
 * instant must read the same for everyone looking at a trace — support, the
 * partner, the airline — and airline time limits (offer expiry, payment time
 * limit, void window) are given in UTC or with an offset, never in the
 * viewer's local time.
 */
@Pipe({
  name: 'formatDate',
})
@Injectable({ providedIn: 'root' })
export class FormatDatePipe implements PipeTransform {
  transform(value: any, formatType: 'request' | 'message' | 'picker' = 'request'): string {
    if (!value) return '';
    const t = moment.utc(value);
    if (!t.isValid()) return '';

    switch (formatType) {
      case 'message':
        return t.format('DD/MM/YYYY @ HH:mm:ss.SSS [UTC]');
      case 'picker':
        return t.format('YYYY-MM-DD');
      case 'request':
      default:
        return t.format('DD/MM/YYYY @ HH:mm:ss [UTC]');
    }
  }
}
